/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SubscriptionEnum,
    SubscriptionEnumFromJSON,
    SubscriptionEnumFromJSONTyped,
    SubscriptionEnumToJSON,
} from './SubscriptionEnum';

/**
 * 
 * @export
 * @interface VerifyAppleReceiptResponseDto
 */
export interface VerifyAppleReceiptResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyAppleReceiptResponseDto
     */
    success: boolean;
    /**
     * 
     * @type {SubscriptionEnum}
     * @memberof VerifyAppleReceiptResponseDto
     */
    subscription: SubscriptionEnum | null;
    /**
     * 
     * @type {string}
     * @memberof VerifyAppleReceiptResponseDto
     */
    subscriptionEndDate: string | null;
}

export function VerifyAppleReceiptResponseDtoFromJSON(json: any): VerifyAppleReceiptResponseDto {
    return VerifyAppleReceiptResponseDtoFromJSONTyped(json, false);
}

export function VerifyAppleReceiptResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyAppleReceiptResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'subscription': SubscriptionEnumFromJSON(json['subscription']),
        'subscriptionEndDate': json['subscriptionEndDate'],
    };
}

export function VerifyAppleReceiptResponseDtoToJSON(value?: VerifyAppleReceiptResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'subscription': SubscriptionEnumToJSON(value.subscription),
        'subscriptionEndDate': value.subscriptionEndDate,
    };
}

